import apiClient from './Request'
import { baseUrls } from './../const'

export default {
  getPatients(organisationId, flag, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/Board/GetPatient?organisationId=' +
        organisationId +
        '&flag=' +
        flag,
      data: data
    })
  },
  getPatientsWithLimit(perPage, page) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/patients?_limit=' + perPage + '&_page=' + page
    )
  },
  postPatients(patient) {
    return apiClient.post(baseUrls['baseUrl'] + '/patients', patient)
  },
  loginUser(user) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/api/user/login',
      data: user
    })
    //return apiClient.post('api/user/Login', user)
  },
  getPadFillProfile(patientId, fromDate, toDate) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Board/GetPadFillV2?patientId=' +
        patientId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate
    )
  },
  getDashboardData() {
    return apiClient.get(baseUrls['baseUrl'] + '/Board/GetDashboardData')
  },
  getPatientDetail(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Board/GetPatientDetail?patientId=' + patientId
    )
  },
  getVoidingPattern(patientId, fromDate, toDate) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Board/GetVoidingPattern?patientId=' +
        patientId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate
    )
  },
  getVoidingPatternPeriod(patientId, fromDate, toDate) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Board/GetVoidingPatternPeriod?patientId=' +
        patientId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate
    )
  },
  GetDeviceStatus(fromDate) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Board/GetDeviceStatus?fromDate=' + fromDate
    )
  },
  GetPositionChart(patientId, fromDate, toDate) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Board/GetPositionChartv2?patientId=' +
        patientId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate
    )
  },
  GetPatientGoal(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/goal/GetPatientGoal?patientId=' + patientId
    )
  },
  SavePadFillProfileGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SavePadFillProfileGoal',
      data: data
    })
  },
  SaveSkinCareGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SaveSkinCareGoal',
      data: data
    })
  },
  SavePositionGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SavePositionGoal',
      data: data
    })
  },
  SaveTemperatureGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SaveTemperatureGoal',
      data: data
    })
  },
  SaveFallGoal(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/goal/SaveFallGoal',
      data: data
    })
  },
  SendEmail(data) {
    return apiClient.post(baseUrls['baseUrl'] + '/email/SendEmailv2', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  GetConsents() {
    return apiClient.get(baseUrls['baseUrl'] + '/data/GetConsents')
  },
  SavePatientConsent(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/data/SavePatientConsent',
      data: data
    })
  },
  SaveUserConsent(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/data/SaveUserConsent',
      data: data
    })
  },
  GetPatientConsent(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/data/GetPatientConsent?patientId=' + patientId
    )
  },
  GetUserConsent() {
    return apiClient.get(baseUrls['baseUrl'] + '/data/GetUserConsent')
  },
  DeletePatient(patientId) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/data/DeletePatient?patientId=' + patientId
    )
  },
  DeleteUser() {
    return apiClient.delete(baseUrls['baseUrl'] + '/api/userv2/deleteuser')
  },
  CheckConnection() {
    return apiClient.get(baseUrls['baseUrl'] + '/Board/CheckConnection')
  },
  GetGroups(filterName) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/data/GetWGroups?filterName=' + filterName
    )
  },
  ChangeGroupStatus(groupId, isUrine) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/data/ChangeGroupStatus?groupId=' +
        groupId +
        '&isUrine=' +
        isUrine
    })
  },
  GetRoles(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/role/getroles?organisationId=' + organisationId
    )
  },
  GetUserRoles(filterName) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/role/getuserroles?filterName=' + filterName
    )
  },
  UpdateUserRole(userId, organisationId, roleId) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/api/user/updateuserrole?userId=' +
        userId +
        '&organisationId=' +
        organisationId,
      data: roleId
    })
  },
  GetRolePermission(roleId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/role/GetRolePermission?roleId=' + roleId
    )
  },
  GetRolePermissionV2(roleId, organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/role/GetRolePermissionV2?roleId=' +
        roleId +
        '&organisationId=' +
        organisationId
    )
  },
  SaveRolePermission(roleId, data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/role/saverolepermissionv2?roleId=' + roleId,
      data: data
    })
  },
  ChangeGroupRetention(months) {
    return apiClient.put(
      baseUrls['baseUrl'] + '/data/ChangeGroupRetention?months=' + months
    )
  },
  ChangeSystemRetention(months) {
    return apiClient.put(
      baseUrls['baseUrl'] + '/data/ChangeSystemRetention?months=' + months
    )
  },
  DeleteRole(roleId) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/role/DeleteRole?roleId=' + roleId
    )
  },
  ResetPassword(userId, data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/api/user/ResetPassword?userId=' + userId,
      data: data
    })
  },
  GetPatientBioPodRecord(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/BioRecord/GetPatientBioPodRecord?patientId=' +
        patientId
    )
  },
  GetBioPodRecord(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/BioRecord/GetBioPodRecord?patientId=' + patientId
    )
  },
  RefreshToken(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/api/user/RefreshTokenv2',
      data: data
    })
  },
  Logout(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/api/user/Logout',
      data: data
    })
  },
  silentFallByPatientId(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Board/SilentFallByPatientId',
      data: data
    })
  },
  getPatientProfile(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Board/GetPatientProfile?patientId=' + patientId
    )
  },
  getPatientPodDetail(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Board/GetPatientPodDetail?patientId=' + patientId
    )
  },
  getUserSite() {
    return apiClient.get(baseUrls['baseUrl'] + '/site/GetUserSite')
  },
  getSiteNodes(siteId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/site/GetSiteNodes?siteId=' + siteId
    )
  },
  getSiteMesh(siteId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/site/GetSiteMesh?siteid=' + siteId
    )
  },
  getSiteMeshV2(siteId, flag, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/site/getsitemeshv2?siteid=' +
        siteId +
        '&flag=' +
        flag,
      data: data
    })
  },
  GetNetworkUtilisation(siteId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/site/GetNetworkUtilisation?siteid=' + siteId
    )
  },
  GetUserGroups(filterName) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/report/GetUserGroups?filterName=' + filterName
    )
  },
  Download(fromDate, toDate, reportId, groups) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/report/Download?fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&reportId=' +
        reportId,
      data: groups,
      responseType: 'blob',
      timeout: 24 * 3600 * 1000
    })
  },
  generateNodeShareCode() {
    return apiClient.get(baseUrls['baseUrl'] + '/site/GenerateNodeShareCode')
  },
  saveGroupPasswordPolicy(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/group/SaveGroupPasswordPolicy',
      data: data
    })
  },
  resetGroupPasswordPolicy() {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/group/ResetGroupPasswordPolicy'
    })
  },
  getGroupPatientTree() {
    return apiClient.get(baseUrls['baseUrl'] + '/group/GetGroupPatientTree')
  },
  getUserPatients() {
    return apiClient.get(baseUrls['baseUrl'] + '/api/User/GetUserPatients')
  },
  GetManufactures() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/manufacture/GetManufactures'
    )
  },
  GetProductsByManufacturerId(manufacturerId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/product/GetProductsByManufacturerId?manufacturerId=' +
        manufacturerId
    )
  },
  GetPodStatusData() {
    return apiClient.get(baseUrls['baseUrl'] + '/Board/GetPodStatusData')
  },
  GetPodStatusDataSample() {
    return apiClient.get(baseUrls['signalRUrl'] + '/GetPodStatusDataSample')
  },
  AddToGroup(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['signalRUrl'] + '/AddToGroup',
      data: data
    })
  },
  GetAllPodsStatus(organisationId, flag, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/Board/GetAllPodsStatus?organisationId=' +
        organisationId +
        '&flag=' +
        flag,
      data: data
    })
  },
  GetPodStatus(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Board/GetPodStatus?patientId=' + patientId
    )
  },
  SaveSite(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/site/savesite',
      data: data
    })
  },
  SaveSiteNode(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/site/SaveSiteNode',
      data: data
    })
  },
  DeleteSiteNode(siteId, macAddress) {
    return apiClient.delete(
      baseUrls['baseUrl'] +
        '/site/DeleteSiteNode?siteId=' +
        siteId +
        '&macAddress=' +
        macAddress
    )
  },
  GetSitePods(siteId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/site/GetSitePods?siteId=' + siteId
    )
  },
  SaveSitePod(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/site/SaveSitePod',
      data: data
    })
  },
  DeleteSitePod(siteId, macAddress) {
    return apiClient.delete(
      baseUrls['baseUrl'] +
        '/site/DeleteSitePod?siteId=' +
        siteId +
        '&macAddress=' +
        macAddress
    )
  },
  GetAllThemes() {
    return apiClient.get(baseUrls['baseUrl'] + '/setting/getallthemes')
  },
  SaveCustomTheme(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/setting/SaveCustomTheme',
      data: data
    })
  },
  DeleteCustomTheme(themeId) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/setting/DeleteCustomTheme?themeId=' + themeId
    )
  },
  GetCustomTheme(name) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/setting/getcustomtheme?name=' + name
    )
  },
  ApplyTheme(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/setting/ApplyTheme',
      data: data
    })
  },
  UploadIMGFile(type, data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/setting/UploadIMGFile?type=' + type,
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  GetAllPatients() {
    return apiClient.get(baseUrls['baseUrl'] + '/membershipv2/GetAllPatientsV2')
  },
  GetAllLocation() {
    return apiClient.get(baseUrls['baseUrl'] + '/setting/getalllocation')
  },
  GetMemberShipGroups() {
    return apiClient.get(baseUrls['baseUrl'] + '/membershipv2/getusergroups')
  },
  SavePatient(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/membershipv2/SavePatient',
      data: data
    })
  },
  DeleteMemberShipPatient(patientId) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/membershipv2/DeletePatient?patientId=' + patientId
    )
  },
  ArchivePatient(patientId) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/membershipv2/ArchivePatient?patientId=' +
        patientId
    })
  },
  GetManufacturersByIds(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/Manufacture/GetManufacturersByIds',
      data: data
    })
  },
  GetManufacturerByCode(code) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/Manufacture/GetManufacturerByCode?code=' +
        code
    )
  },
  GetOrganisationManufacturer(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/organisation/GetOrganisationManufacturer?organisationId=' +
        organisationId
    )
  },
  AddOrganisationManufacturer(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/organisation/addorganisationmanufacturer',
      data: data
    })
  },
  UnArchivePatient(patientId) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/membershipv2/UnArchivePatient?patientId=' +
        patientId
    })
  },
  GetPatientNodes() {
    return apiClient.get(baseUrls['baseUrl'] + '/membershipv2/GetPatientNodes')
  },
  AssignNodeToPatient(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/membershipv2/AssignNodeToPatient',
      data: data
    })
  },
  UnAssignNodeFromPatient(data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/membershipv2/UnAssignNodeFromPatient',
      data: data
    })
  },
  CreateGroup(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/membershipv2/CreateGroupv2',
      data: data
    })
  },
  EditGroup(data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/membershipv2/EditGroup',
      data: data
    })
  },
  DeleteMemberShipGroup(groupId) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/membershipv2/deletegroup?groupId=' + groupId
    )
  },
  CreateUser(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/membershipv2/createuserv2',
      data: data
    })
  },
  CreateUserAccount(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/api/user/createUser',
      data: data
    })
  },
  UpdateUserAccount(userId, data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/api/user/updateUser?userId=' + userId,
      data: data
    })
  },
  DeleteUserAccount(userId) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/api/user/deleteUser?userId=' + userId
    )
  },
  GetAllUserAccount(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/api/user/getallusersv2?organisationId=' +
        organisationId
    )
  },
  SaveOrganisationDateTimeSettings(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/group/saveOrganisationDateTimeSettings',
      data: data
    })
  },
  GetUserGroupsV2(filterName) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/group/GetUserGroupsV2?filterName=' + filterName
    )
  },
  DownloadReport(organisationId, fromDate, toDate, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/Report/GetReport?organisationId=' +
        organisationId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&ReportType=1',
      data: data
    })
  },
  GetAllRegions() {
    return apiClient.get(baseUrls['baseUrl'] + '/setting/getAllRegions')
  },
  SaveOrganisation(data) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/Organisation/SaveOrganisation',
      data
    )
  },
  VerifyUser(domainName) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/api/userv2/verifyuser?domainName=' + domainName
    )
  },
  SaveBuilding(data) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/Organisation/savebuilding',
      data
    )
  },
  GetBuildings(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/organisation/getbuildings?organisationId=' +
        organisationId
    )
  },
  DeleteBuilding(buildingIds) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/organisation/deletebuilding',
      data: buildingIds
    })
  },
  GetAllPatientsV3(organisationId, flag, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['baseUrl'] +
        '/membershipv2/GetAllPatientsV3?organisationId=' +
        organisationId +
        '&flag=' +
        flag,
      data: data
    })
  },
  DeleteOrganisationManufacturer(manufacturerId, organisationId) {
    return apiClient.delete(
      baseUrls['baseUrl'] +
        '/organisation/deleteorganisationmanufacturer?manufacturerId=' +
        manufacturerId +
        '&organisationId=' +
        organisationId
    )
  },
  GetOrganisationDetail(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/organisation/getorganisationDetail?organisationId=' +
        organisationId
    )
  },
  GetOrganisationPatients(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/organisation/GetOrganisationPatients?organisationId=' +
        organisationId
    )
  },
  DeleteUserFromOrganisation(userId, organisationId) {
    return apiClient.delete(
      baseUrls['baseUrl'] +
        '/organisation/deleteuserfromorganisation?userId=' +
        userId +
        '&organisationId=' +
        organisationId
    )
  },
  GetReportHistory(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/report/getreporthistory?organisationId=' +
        organisationId
    )
  },
  InviteUser(data) {
    return apiClient.post(baseUrls['baseUrl'] + '/organisation/Invite', data)
  },
  JoinOrganisation(code) {
    return apiClient.put(
      baseUrls['baseUrl'] + '/organisation/join?code=' + code
    )
  },
  GetOrganisationProfile(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/organisation/GetOrganisationProfile?organisationId=' +
        organisationId
    )
  },
  VerifyInvitation(invitationToken) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/organisation/VerifyInvitation?invitationToken=' +
        invitationToken
    )
  },
  SaveAreaDetail(data) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/organisation/saveareadetail',
      data
    )
  },
  GetBuildingAreas(buildingId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/organisation/getbuildingwards?buildingId=' +
        buildingId
    )
  },
  GetAreaByIds(wardIds) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/organisation/getwarddetail',
      data: wardIds
    })
  },
  DeleteWard(wardId) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/organisation/deleteward?wardId=' + wardId
    )
  },
  GetUserFilter(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/api/userv2/getuserfilter?organisationId=' +
        organisationId
    )
  },
  SaveUserFilter(data) {
    return apiClient.post(
      baseUrls['baseUrl'] + '/api/userv2/saveuserfilter',
      data
    )
  },
  GetAzureUserDetail() {
    return apiClient.get(baseUrls['baseUrl'] + '/api/userv2/GetAzureUserDetail')
  },
  GetPatientDataExport(organisationId, patientId) {
    return apiClient.put(
      baseUrls['baseUrl'] +
        '/report/getpatientdataexport?organisationId=' +
        organisationId +
        '&patientId=' +
        patientId
    )
  },
  GetPatientReportHistory(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/report/getpatientexporthistory?organisationId=' +
        organisationId
    )
  },
  GetPatientEventRecord(patientId, fromDate, toDate) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/board/GetPatientEventRecord?fromDate=' +
        fromDate +
        '&patientId=' +
        patientId +
        '&toDate=' +
        toDate
    )
  },
  GetPatientVoidRecord(patientId, fromDate, toDate) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Board/GetPatientVoidRecord?fromDate=' +
        fromDate +
        '&patientId=' +
        patientId +
        '&toDate=' +
        toDate
    )
  },
  GetOrganisations(domainName) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/organisation/getorganisations?domainName=' +
        domainName
    )
  },
  GetIndividualPatientDetail(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/membershipv2/getpatientdetail?patientId=' +
        patientId
    )
  },
  SaveFloor(data) {
    return apiClient.post(baseUrls['baseUrl'] + '/organisation/savefloor', data)
  },
  SaveRoom(data) {
    return apiClient.post(baseUrls['baseUrl'] + '/organisation/saveroom', data)
  },
  DeleteFloor(floorIds) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/organisation/deletefloor',
      data: floorIds
    })
  },
  DeleteRoom(roomIds) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/organisation/deleteroom',
      data: roomIds
    })
  },
  GetPatientHistory(patientId) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/goal/GetPatientHistory?patientId=' + patientId
    )
  },
  GetNonSmartzPad() {
    return apiClient.get(baseUrls['baseUrl'] + '/membershipv2/GetNonSmartzPad')
  }
}
